import React from "react";
import styles from "./EmptyPage.module.scss";
import CancellationNotifications from "../../components/CancellationNotifications/CancellationNotifications";
import Billing from "../../components/Billing/Billing";
import MatchingButton from "../../components/MatchingButton/MatchingButton";

import { useClient } from "../../redux/client";
const EmptyPage = () => {
  const client = useClient();
  return (
    <div
      data-testid="EmptyPage"
      className={`${styles.EmptyPage} container-fluid container-xl container-lg my-0 mx-auto px-0`}
    >
      <CancellationNotifications />
      <div className="header-container">
        <h2 className="mg-b-l">Welcome to Magic, {client.profile.name}!</h2>
        <div className={styles.Card}>
          <b className="text">You don’t have any assistants working for you right now.</b>
          <p>
            Browse available assistants on the Magic platform, or talk to an experienced Matching
            Agent who can help get an assistant to meet your needs.
          </p>
          <MatchingButton type="dark" />
        </div>
        <div className="mb-5" />
        <Billing />
      </div>
    </div>
  );
};

export default EmptyPage;
